import { getYear } from 'date-fns';
import { useMemo } from 'react';

import { Text } from '@bai/components';

interface FooterProps {
  hideBorder?: boolean;
  textColor?: string;
}

export function Footer({ hideBorder, textColor }: FooterProps) {
  const year = useMemo(() => getYear(new Date()), []);

  const footerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: hideBorder ? 'none' : '2px solid black',
    paddingTop: '1.5rem',
    width: 'calc(100vw - 30px)',
    marginLeft: '15px', // 15px aligns with hamburger menu and logout link
  };

  const linkStyle = {
    marginTop: '-4px',
    color: textColor ?? 'black',
  };

  const textStyle = {
    color: textColor ?? 'black',
  };

  return (
    <footer style={footerStyle} data-cy="footer" print-remove="true">
      <Text variant="caption" style={textStyle}>
        &nbsp;{year}&nbsp;©&nbsp;
      </Text>
      <a style={linkStyle} href="https://www.prosightfa.org/">
        <Text variant="caption" style={textStyle}>
          ProSight Financial Association
        </Text>
      </a>
    </footer>
  );
}

export default Footer;
